"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPinInput = _interopRequireDefault(require("react-pin-input"));
var _validations = _interopRequireDefault(require("./validations"));
var Pin = function Pin(_ref) {
  var _ref$input = _ref.input,
    _onChange = _ref$input.onChange,
    name = _ref$input.name,
    pinLength = _ref.pinLength,
    disabled = _ref.disabled,
    autoFocus = _ref.config.autoFocus;
  return /*#__PURE__*/_react["default"].createElement(_reactPinInput["default"], {
    focus: autoFocus,
    length: pinLength,
    type: "numeric",
    secret: true,
    style: {
      display: 'flex',
      justifyContent: 'center'
    },
    onChange: function onChange(value) {
      _onChange(value);
    },
    id: "pin-".concat(name),
    disabled: disabled
  });
};
Pin.defaultProps = {
  pinLength: 6,
  config: {}
};
Pin.propTypes = {
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    name: _propTypes["default"].string.isRequired
  }),
  pinLength: _propTypes["default"].number
};
var _default = exports["default"] = Pin;